import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-gis-position-add',
  templateUrl: './gis-position-add.component.html',
  styleUrls: ['./gis-position-add.component.css']
})
export class GisPositionAddComponent implements OnInit {
    argType;

    argValue;

    lat;

    lng;

    public edit?: Edit;

    public readyGisPositionNote = true;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.lat = this.stateService.getStateParams()['lat'];
        this.lng = this.stateService.getStateParams()['lng'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue && !!this.lat && !!this.lng) {
            this.edit = (await this.datatask.Post(1284, {
                argtype: this.argType,
                argvalue: this.argValue,
                lat: this.lat,
                lng: this.lng
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1285, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    argtype: string;
    argvalue: string;
    lat: string;
    lng: string;
    gisposition_name: string;
    gisposition_note: string;
}
